// extracted by mini-css-extract-plugin
export var statItem = "_hz-1";
export var statsRow = "_hz-0";